import { ReactElement } from 'react'
import { useAppSelector } from '../../../redux/hooks'
import { getIsMobile } from '../../../redux/reducers/appSettings'
import { PropsCompanyCardPage } from './props'
import CompanyCardTemplate from './template'

const CompanyCardPage = ({
    children,
    choosenText = [],
    onClickNext,
    open,
    setOpen,
    showNextButton,
    title,
    dataCy
}: PropsCompanyCardPage): ReactElement => { const isMobile = useAppSelector((state) => getIsMobile(state))

    const choosenTextFiltered = choosenText.filter(
        (text) => text !== '' && text !== undefined
    )
    const hasValueChoosen = choosenTextFiltered.length > 0

    return (
        <CompanyCardTemplate
            choosenText={choosenTextFiltered}
            hasValueChoosen={hasValueChoosen}
            isMobile={isMobile}
            onClickNext={onClickNext}
            open={open}
            setOpen={setOpen}
            showNextButton={showNextButton}
            title={title}
            dataCy={dataCy}
        >
            {children}
        </CompanyCardTemplate>
    )
}

export default CompanyCardPage
